var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6086 1.89204C10.8527 2.13612 10.8527 2.53185 10.6086 2.77593L1.44194 11.9426C1.19786 12.1867 0.802136 12.1867 0.558058 11.9426C0.313981 11.6985 0.313981 11.3028 0.558058 11.0587L9.72473 1.89204C9.9688 1.64796 10.3645 1.64796 10.6086 1.89204Z",
    fill: "#5C6670"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.374 2.12598C10.3161 2.12504 10.2492 2.12502 10.1666 2.12502H5.16663C4.82145 2.12502 4.54163 1.84519 4.54163 1.50002C4.54163 1.15484 4.82145 0.875015 5.16663 0.875015H10.1666C10.1761 0.875015 10.1857 0.875011 10.1953 0.875008C10.3663 0.87494 10.5511 0.874868 10.7071 0.895843C10.8899 0.920416 11.1234 0.983612 11.3199 1.18011C11.5164 1.37661 11.5796 1.6101 11.6041 1.79287C11.6251 1.94889 11.625 2.13372 11.625 2.30465C11.625 2.31426 11.625 2.32383 11.625 2.33335V7.33335C11.625 7.67853 11.3451 7.95835 11 7.95835C10.6548 7.95835 10.375 7.67853 10.375 7.33335V2.33335C10.375 2.25078 10.3749 2.18386 10.374 2.12598Z",
    fill: "#5C6670"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopRight);
export default __webpack_public_path__ + "static/media/arrowTopRight.0badab2532851e48c08726d340d8c70b.svg";
export { ForwardRef as ReactComponent };